import React, { useState } from 'react';
import { Button } from '../ui/button';

interface PasteFromExcelProps {
  className?: string;
  pasteDataFromExcel: (data: any[]) => void
}

const PasteFromExcel: React.FC<PasteFromExcelProps> = ({ className, pasteDataFromExcel }) => {
    const [rows, setRows] = useState<{ cells: string[] }[]>([]);

    const handleClick = async () => {
        try {
            const text = await navigator.clipboard.readText();
            const rowData = text.split('\n').map(row => ({
                cells: row.split('\t') 
            }));
            pasteDataFromExcel(rowData)
            setRows(rowData);
        } catch (error) {
            console.error('Failed to read clipboard contents: ', error);
        }
    };

    return (
        <div className={className}>
            <Button variant="outline" onClick={handleClick}>Paste from excel</Button>
        </div>
    );
};

export default PasteFromExcel;
